<script>
export default {
  name: 'FilterTags',
  props: {
    viewMoreLabel: {
      type: String,
      default: null,
    },
    viewLessLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      viewMoreFilterTags: null,
      expanded: null,
    };
  },
  mounted() {
    const filterTagsCount = this.$el.querySelectorAll('.filter-tag').length;
    const filterTagsSelectedCount = this.$el.querySelectorAll('.filter-tag--selected').length;
    this.expanded = false;

    this.viewMoreFilterTags = filterTagsCount > 5;

    if (filterTagsCount === filterTagsSelectedCount) {
      this.viewMoreFilterTags = false;
    }
  },
  methods: {
    handleViewMoreFilterTags() {
      this.expanded = !this.expanded;
    },
  },
  computed: {
    activeViewMoreLabel() {
      return this.expanded ? this.viewLessLabel : this.viewMoreLabel;
    },
  },
};
</script>
